import './scripts/i18n';

import App from './scripts/app';
import AppContext from './scripts/context/app-context';
import React from 'react';
import ReactDom from 'react-dom';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

// Render
// ------
(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LD_KEY as string,
    options: {
      sendEventsOnlyForVariation: true,
    },
  });

  ReactDom.render(
    <React.StrictMode>
      <LDProvider>
        <AppContext>
          <App />
        </AppContext>
      </LDProvider>
    </React.StrictMode>,
    document.querySelector('.app-container')
  );
})();
